import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const DisableSUTDescription = () =>
  <Paragraph>
    <strong>
      <Color variant='theme-description-text'>
        Disabling the SUT will prevent it from being used when running tests.
      </Color>
    </strong>
  </Paragraph>

export default DisableSUTDescription
